import React from 'react'
import GameCardStyle from './GameCardStyle'
import ButtonSmall from '../ui/ButtonSmall'

const GameCard = ({
  image,
  altText,
  title,
  firstPar,
  secondPar,
  linkOne,
  linkTwo,
}) => {
  return (
    <GameCardStyle>
      <div>
        <h4>{title}</h4>
        <p>{firstPar}</p>
        <p>{secondPar}</p>
        <>
          {/* {(linkOne && (
            <a href={linkOne} target="_blank" rel="noopener noreferrer">
              Play It
            </a>
          )) ||
            ''}
          {(linkTwo && (
            <a href={linkTwo} target="_blank" rel="noopener noreferrer">
              Buy It
            </a>
          )) ||
            ''} */}
          {(linkOne && (
            <ButtonSmall
              as="a"
              href={linkOne}
              target="_blank"
              rel="noopener noreferrer"
            >
              Play It
            </ButtonSmall>
          )) ||
            ''}
          {(linkTwo && (
            <ButtonSmall
              as="a"
              href={linkTwo}
              target="_blank"
              rel="noopener noreferrer"
            >
              Buy It
            </ButtonSmall>
          )) ||
            ''}
        </>
      </div>
      <img src={image} alt={altText} />
    </GameCardStyle>
  )
}

export default GameCard
